/**
 * Quiz Results Page Logic
 */

function formatPriceCents(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Add class to body to hide header
document.body.classList.add('quiz-results-page-active');

// Configure base URL for breed images if not already defined
window.SHOPIFY_CDN_BASE_URL = window.SHOPIFY_CDN_BASE_URL || 'https://cdn.shopify.com/s/files/1/0817/9125/4828/files/';

// Fallback breeds for variants without parentheses
const BREED_FALLBACKS = {
  'poodle': 'poodle__standard',
  'bulldog': 'bulldog__american'
};

// Convert breed name to CDN filename slug
function getBreedSlug(breed) {
  if (!breed) return '';
  const lowerBreed = breed.toLowerCase();
  const parenMatch = lowerBreed.match(/^(.+?)\s*\((.+?)\)$/);
  if (parenMatch) {
    const base = parenMatch[1].trim().replace(/\s+/g, '_');
    const variant = parenMatch[2].trim().replace(/\s+/g, '_');
    return `${base}__${variant}`;
  }
  const simpleSlug = lowerBreed.replace(/\s+/g, '_');
  if (BREED_FALLBACKS[simpleSlug]) {
    return BREED_FALLBACKS[simpleSlug];
  }
  return simpleSlug;
}

// Initialize page
document.addEventListener('DOMContentLoaded', function() {
  // Give scripts time to load, especially quiz.calculator.js
  setTimeout(function() {
    initQuizResults();
  }, 100);
});

// Check if we're in Shopify design/preview mode
const isDesignMode = (window.Shopify && window.Shopify.designMode) || false;

function initQuizResults() {
  // If in design mode, show preview with sample data
  if (isDesignMode) {
    showPreviewMode();
    return;
  }

  // Migrate old localStorage data to add tracking fields
  migrateOldData();

  // Check if calculator is loaded
  if (!window.QuizCalculator) {
    console.error('[Quiz Results] QuizCalculator not loaded!');
    showError('Error loading calculator. Please refresh the page.');
    return;
  }

  // Get quiz data from URL or localStorage
  const quizData = getQuizData();

  if (!quizData) {
    console.error('[Quiz Results] No quiz data found');
    showError();
    return;
  }

  try {
    // Always render dog tabs first (even for incomplete dogs)
    renderDogTabs(quizData);

    // Check if current dog is complete
    if (!isDogComplete(quizData)) {
      showIncompleteMessage(quizData);
      return;
    }

    // Render results for complete dog
    renderDogInfo(quizData);
    renderRecommendedProducts(quizData);
    renderIndividualProducts(quizData);
    initPurchaseOptions();

    // Show content (was hidden by default to prevent flash)
    document.querySelectorAll('.quiz-results-main, .quiz-purchase-options, .quiz-scrolling-text, .quiz-buy-separately').forEach(el => {
      el.classList.add('visible');
    });
    
    // Dispatch event for other sections
    window.dispatchEvent(new CustomEvent('quizResultsReady', { detail: window.quizResultsData }));
  } catch (error) {
    console.error('[Quiz Results] Error during initialization:', error);
    showError('An error occurred. Please try again or contact support.');
  }
}

// Preview mode for Shopify theme editor
function showPreviewMode() {
  // Sample preview data
  const previewData = {
    source: 'preview',
    dogName: 'Luna', // Will be overwritten by Liquid if section settings exist
    dogBreed: 'Golden Retriever',
    weight: 65,
    calories: 1200,
    bagWeight: '19lb',
    deliveryCadence: 4,
    foodFlavor: 'chicken',
    treatFlavor: 'beef',
    support: ['joint'],
    allergies: false
  };

  // Hide dog tabs in preview
  const tabsContainer = document.getElementById('quiz-results-dog-tabs');
  if (tabsContainer) tabsContainer.style.display = 'none';

  // Render preview content
  renderDogInfo(previewData);

  // Render sample products if available
  const container = document.getElementById('quiz-recommended-products');
  // We rely on window.quizResultsData.allProducts being populated by Liquid
  const allProducts = window.quizResultsData && window.quizResultsData.allProducts ? window.quizResultsData.allProducts : [];
  const sampleProducts = allProducts.slice(0, 3);

  if (sampleProducts.length > 0) {
    container.innerHTML = sampleProducts.map(product => `
      <div class="quiz-product-card">
        <img src="${product.featured_image}" alt="${product.title}">
        <h3>${product.title}</h3>
      </div>
    `).join('');

    // Store for individual products
    window.quizResultsData = window.quizResultsData || {};
    window.quizResultsData.recommendations = { products: sampleProducts };
    renderIndividualProducts(previewData);
  }
  
  initPurchaseOptions();

  // Show content
  document.querySelectorAll('.quiz-results-main, .quiz-purchase-options, .quiz-scrolling-text, .quiz-buy-separately').forEach(el => {
    el.classList.add('visible');
  });
  
  window.dispatchEvent(new CustomEvent('quizResultsReady', { detail: window.quizResultsData }));
}

// Migrate old localStorage data to add per-dog tracking fields
function migrateOldData() {
  const savedData = localStorage.getItem('kismet_quiz_data');
  if (!savedData) return;

  try {
    const data = JSON.parse(savedData);
    if (!data.dogs) return;

    let needsSave = false;

    data.dogs.forEach((dog, index) => {
      if (dog.currentStep === undefined) {
        if (dog.diet) {
          dog.currentStep = 8;
          dog.completed = true;
        } else if (dog.support && dog.support.length > 0) {
          dog.currentStep = 7;
        } else if (dog.activityLevel) {
          dog.currentStep = 6;
        } else if (dog.size) {
          dog.currentStep = 5;
        } else if (dog.weight > 0) {
          dog.currentStep = 4;
        } else if (dog.birthdayMonth) {
          dog.currentStep = 3;
        } else if (dog.breed) {
          dog.currentStep = 3;
        } else {
          dog.currentStep = 2;
        }
        needsSave = true;
      }

      if (dog.completed === undefined) {
        dog.completed = !!(dog.diet && dog.activityLevel && dog.weight > 0 && dog.breed && dog.size);
        needsSave = true;
      }
    });

    if (needsSave) {
      localStorage.setItem('kismet_quiz_data', JSON.stringify(data));
    }
  } catch (e) {
    console.error('[Quiz Results] Error migrating data:', e);
  }
}

function isDogComplete(quizData) {
  const savedData = localStorage.getItem('kismet_quiz_data');
  if (!savedData) return false;

  const data = JSON.parse(savedData);
  const params = new URLSearchParams(window.location.search);
  const cdi = parseInt(params.get('cdi') || '0', 10);
  const dog = data.dogs && data.dogs[cdi];

  if (!dog) return false;

  if (dog.completed === true) return true;
  if (dog.currentStep && dog.currentStep > 7) return true;
  if (quizData.source === 'url' && quizData.calories > 0) return true;
  if (dog.currentStep !== undefined) return false;

  return dog.breed && dog.weight > 0 && dog.activityLevel && dog.diet && dog.size && dog.gender;
}

function showIncompleteMessage(quizData) {
  const mainContent = document.querySelector('.quiz-results-main');
  const purchaseOptions = document.querySelector('.quiz-purchase-options');
  const scrollingText = document.querySelector('.quiz-scrolling-text');
  const buySeparately = document.querySelector('.quiz-buy-separately');
  const retakeSection = document.querySelector('.quiz-retake-section');

  if (mainContent) mainContent.style.display = 'none';
  if (purchaseOptions) purchaseOptions.style.display = 'none';
  if (scrollingText) scrollingText.style.display = 'none';
  if (buySeparately) buySeparately.style.display = 'none';
  if (retakeSection) retakeSection.style.display = 'none';

  const dogName = quizData.dogName || 'this dog';
  const params = new URLSearchParams(window.location.search);
  const cdi = parseInt(params.get('cdi') || '0', 10);

  let dogStep = 2;
  const savedData = localStorage.getItem('kismet_quiz_data');
  if (savedData) {
    const data = JSON.parse(savedData);
    const dog = data.dogs && data.dogs[cdi];
    if (dog && dog.currentStep) {
      dogStep = dog.currentStep;
    }
  }

  // Build quiz URL with params (handle URLs that may already have query params)
  const baseQuizUrl = (window.quizResultsData && window.quizResultsData.quizUrl) || '/pages/account?view=quiz';
  const separator = baseQuizUrl.includes('?') ? '&' : '?';
  const quizUrlWithParams = `${baseQuizUrl}${separator}dog=${cdi}&step=${dogStep}`;

  const incompleteHtml = `
    <div class="quiz-incomplete-message">
      <h2>Almost there!</h2>
      <p>You haven't finished the quiz for <strong>${dogName}</strong> yet. Complete the quiz to see personalized food recommendations.</p>
      <a href="${quizUrlWithParams}" class="quiz-complete-btn">Complete Quiz for ${dogName}</a>
    </div>
  `;

  // Remove existing message if any
  const existingMsg = document.querySelector('.quiz-incomplete-message');
  if(existingMsg) existingMsg.remove();

  const tabsContainer = document.getElementById('quiz-results-dog-tabs');
  if (tabsContainer) {
    tabsContainer.insertAdjacentHTML('afterend', incompleteHtml);
  }
}

function getQuizData() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('cdi')) {
    try {
      const cdi = parseInt(params.get('cdi') || '0', 10);
      const names = (params.get('n') || '').split(',');
      const breeds = (params.get('b') || '').split(',').map(b => decodeURIComponent(b));
      const weights = (params.get('w') || '').split(',');
      const calories = (params.get('cal') || '').split(',');
      const foodFlavors = (params.get('ff') || '').split(',');
      const treatFlavors = (params.get('tf') || '').split(',');
      const bagWeights = (params.get('bw') || '').split(',');
      const cadences = (params.get('dc') || '').split(',');
      const support = (params.get('sp') || '').split(',');

      const getFlavor = (num) => {
        if(num == '1') return 'salmon';
        if(num == '2') return 'beef';
        if(num == '3') return 'chicken';
        return 'chicken';
      };

      if (names[cdi]) {
        return {
          source: 'url',
          dogName: names[cdi],
          dogBreed: breeds[cdi] || '',
          weight: parseFloat(weights[cdi] || 0),
          calories: parseInt(calories[cdi] || 0),
          bagWeight: bagWeights[cdi],
          deliveryCadence: parseInt(cadences[cdi] || 4),
          foodFlavor: getFlavor(foodFlavors[cdi]),
          treatFlavor: getFlavor(treatFlavors[cdi]),
          support: support[cdi] ? [support[cdi]] : [],
          allergies: foodFlavors[cdi] == '1'
        };
      }
    } catch (e) {
      console.error('[Quiz Results] Error parsing URL params:', e);
    }
  }

  const savedData = localStorage.getItem('kismet_quiz_data');
  if (savedData) {
    const data = JSON.parse(savedData);
    const cdi = parseInt(params.get('cdi') || '0', 10);
    const dog = data.dogs && data.dogs[cdi] ? data.dogs[cdi] : (data.dogs ? data.dogs[0] : null);

    if (dog) {
      return {
        source: 'local',
        dogName: dog.name || 'Your dog',
        dogBreed: dog.breed,
        weight: parseFloat(dog.weight) || 0,
        activityLevel: dog.activityLevel,
        size: dog.size,
        spayedOrNeutered: dog.spayedOrNeutered === 'true' || dog.spayedOrNeutered === true,
        birthdayMonth: dog.birthdayMonth,
        birthdayDay: parseInt(dog.birthdayDay) || 1,
        birthdayYear: parseInt(dog.birthdayYear) || 2023,
        allergies: dog.allergies === 'true' || dog.allergies === true,
        support: dog.support,
        diet: dog.diet,
        gender: dog.gender
      };
    }
  }

  return null;
}

function renderDogInfo(data) {
  const dogName = data.dogName || 'Your dog';
  const nameEls = document.querySelectorAll('#quiz-dog-name, #dog-name-inline');
  nameEls.forEach(el => el.textContent = dogName);

  if (data.dogBreed && window.SHOPIFY_CDN_BASE_URL) {
    const breedSlug = getBreedSlug(data.dogBreed);
    const imageUrl = window.SHOPIFY_CDN_BASE_URL + 'breed_' + breedSlug + '.png';
    const imgContainer = document.getElementById('quiz-dog-image');
    if (imgContainer) {
      imgContainer.innerHTML =
        `<img src="${imageUrl}" alt="${data.dogBreed}" style="width: 100%; height: auto;" onerror="this.style.display='none'">`;
    }
  }
}

function renderRecommendedProducts(data) {
  // Use allProducts from global scope (injected by Liquid)
  const allProducts = window.quizResultsData && window.quizResultsData.allProducts ? window.quizResultsData.allProducts : [];
  
  let calories, bagWeight, deliveryCadence, treatType;

  if (data.source === 'url') {
    calories = data.calories;
    bagWeight = data.bagWeight;
    deliveryCadence = data.deliveryCadence;
    treatType = window.QuizCalculator.determineTreatType(data.weight);
  } else {
    calories = window.QuizCalculator.calculateRecommendations(data);
    bagWeight = window.QuizCalculator.calculateBagWeight(calories);
    deliveryCadence = window.QuizCalculator.calculateDeliveryCadence(calories, bagWeight);
    treatType = window.QuizCalculator.determineTreatType(data.weight);
  }

  const textContainer = document.getElementById('quiz-recommendation-text');
  if (textContainer) {
    textContainer.innerHTML = `
      Based on your answers, we have done some calculations behind the scenes and recommend <strong>${calories} calories</strong> a day of our nutritious and delicious food for <span id="dog-name-inline">${data.dogName}</span>. See below for the type of food, bag size, and order frequency that best fits needs, lifestyle, and caloric intake.
    `;
  }

  let foodFlavor = data.foodFlavor || (data.allergies ? 'salmon' : 'chicken');
  let treatFlavor = data.treatFlavor || (data.allergies ? (Math.random() > 0.5 ? 'salmon' : 'beef') : 'beef');

  const mainFoodProduct = findFoodProduct(allProducts, foodFlavor, bagWeight);
  const shakersProduct = findShakersProduct(allProducts, data.support);
  const treatProduct = findTreatProduct(allProducts, treatFlavor, treatType);

  const recommendedProducts = [];
  if (mainFoodProduct) recommendedProducts.push({ ...mainFoodProduct, type: 'food', bagWeight });
  if (shakersProduct) recommendedProducts.push({ ...shakersProduct, type: 'shakers' });
  if (treatProduct) recommendedProducts.push({ ...treatProduct, type: 'treat' });

  // Store for global use in object for consistency
  window.quizResultsData = window.quizResultsData || {};
  window.quizResultsData.recommendations = { calories, bagWeight, deliveryCadence, products: recommendedProducts };
  
  if (recommendedProducts.length === 0 && !isDesignMode) {
    showError('We couldn\'t find matching products. Please contact our team for personalized recommendations.');
    return;
  }

  const deliverySelect = document.getElementById('delivery-frequency');
  if (deliverySelect) {
    const hasOption = Array.from(deliverySelect.options).some(opt => opt.value == deliveryCadence);
    if (!hasOption && deliveryCadence) {
      const option = document.createElement('option');
      option.value = deliveryCadence;
      option.textContent = `Delivery every ${deliveryCadence} weeks`;
      option.selected = true;
      deliverySelect.insertBefore(option, deliverySelect.firstChild);
    } else {
      deliverySelect.value = deliveryCadence;
    }
  }

  const container = document.getElementById('quiz-recommended-products');
  if (container) {
    container.innerHTML = recommendedProducts.map(product => {
      const variant = product.type === 'food' && product.bagWeight
        ? product.variants.find(v => v.title.includes(product.bagWeight))
        : product.variants[0];
      const price = variant ? variant.price : product.price;
      const compareAt = product.compare_at_price && product.compare_at_price > price ? product.compare_at_price : 0;

      return `
        <div class="quiz-product-card">
          <img src="${product.featured_image}" alt="${product.title}">
          <div class="quiz-product-card__meta">
            <h3>${product.title}</h3>
            <span class="quiz-product-card__current-price">${formatPriceCents(price)}</span>
          </div>
        </div>
      `;
    }).join('');
  }
}

function renderIndividualProducts(data) {
  if (!window.quizResultsData || !window.quizResultsData.recommendations || !window.quizResultsData.recommendations.products) return;

  const container = document.getElementById('quiz-individual-products');
  const templatesContainer = document.getElementById('quiz-quick-add-templates');
  const products = window.quizResultsData.recommendations.products;

  if (container) {
    // Clear container
    container.innerHTML = '';

    products.forEach(product => {
      const productUrl = product.url || `/products/${product.handle}`;

      // Create product card
      const productCard = document.createElement('div');
      productCard.className = 'quiz-individual-product';
      productCard.dataset.productId = product.id;

      // Create image wrapper (will contain quick-add overlay)
      const imageWrap = document.createElement('div');
      imageWrap.className = 'quiz-individual-product__image-wrap';

      // Create link for image
      const imageLink = document.createElement('a');
      imageLink.href = productUrl;
      imageLink.target = '_blank';
      imageLink.rel = 'noopener';
      imageLink.className = 'quiz-individual-product__image-link';
      imageLink.innerHTML = `<img src="${product.featured_image}" alt="${product.title}">`;

      // Create quick-add container (inside image wrapper for overlay)
      const quickAddContainer = document.createElement('div');
      quickAddContainer.className = 'quiz-individual-product__quick-add';

      // Try to clone the pre-rendered quick-add component
      let hasQuickAdd = false;
      if (templatesContainer) {
        const template = templatesContainer.querySelector(`[data-product-id="${product.id}"]`);
        if (template) {
          // Clone all children from template (including quick-add-inline element)
          const quickAddElement = template.querySelector('quick-add-inline');
          if (quickAddElement) {
            const clonedElement = quickAddElement.cloneNode(true);
            quickAddContainer.appendChild(clonedElement);
            hasQuickAdd = true;
          }
        }
      }

      // Fallback to simple button if no pre-rendered template
      if (!hasQuickAdd) {
        const firstVariant = product.variants && product.variants[0];
        const variantId = firstVariant ? firstVariant.id : '';
        const fallbackBtn = document.createElement('button');
        fallbackBtn.type = 'button';
        fallbackBtn.className = 'quiz-individual-product__quick-add-btn';
        fallbackBtn.dataset.variantId = variantId;
        fallbackBtn.dataset.productUrl = productUrl;
        fallbackBtn.textContent = 'Quick Add';
        fallbackBtn.addEventListener('click', handleQuickAdd);
        quickAddContainer.appendChild(fallbackBtn);
      }

      // Assemble image wrapper with link and quick-add overlay
      imageWrap.appendChild(imageLink);
      imageWrap.appendChild(quickAddContainer);

      // Create meta row (title + price)
      const metaWrap = document.createElement('div');
      metaWrap.className = 'quiz-individual-product__meta';

      const titleLink = document.createElement('a');
      titleLink.href = productUrl;
      titleLink.target = '_blank';
      titleLink.rel = 'noopener';
      titleLink.className = 'quiz-individual-product__title-link';
      titleLink.innerHTML = `<h3>${product.title}</h3>`;

      const firstVariant = product.variants && product.variants[0];
      const displayPrice = firstVariant ? firstVariant.price : product.price;
      const priceEl = document.createElement('span');
      priceEl.className = 'quiz-individual-product__price';
      priceEl.textContent = formatPriceCents(displayPrice);

      metaWrap.appendChild(titleLink);
      metaWrap.appendChild(priceEl);

      // Assemble product card
      productCard.appendChild(imageWrap);
      productCard.appendChild(metaWrap);
      container.appendChild(productCard);
    });
  }
}

function handleQuickAdd(e) {
  e.preventDefault();
  e.stopPropagation();

  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  const productUrl = btn.dataset.productUrl;

  if (!variantId) {
    // No variant, redirect to product page
    window.open(productUrl, '_blank');
    return;
  }

  // Show loading state
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }],
      sections: ['cart-ajax']
    })
  })
  .then(response => response.json())
  .then(data => {
    btn.textContent = 'Added!';
    btn.classList.add('success');

    // Dispatch standard cart event so header cart drawer updates and opens
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      detail: { product: data, addToCartBtn: btn }
    }));

    // Reset button after delay
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.classList.remove('success');
    }, 2000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    btn.textContent = 'Error';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  });
}

function findFoodProduct(products, flavor, bagWeight) {
  if (!products) return null;
  return products.find(p => {
    const title = p.title.toLowerCase();
    const type = p.type ? p.type.toLowerCase() : '';
    const isTreat = title.includes('stick') || title.includes('square') || isTopper(p) || type.includes('treat');
    if (!isTreat && title.includes(flavor.toLowerCase())) {
      return p.variants.some(v => v.title.includes(bagWeight));
    }
    return false;
  });
}

// Toppers are matched on product type, not on the word "Shakers": the line was
// renamed to "Kismet Daily <benefit> Formula" (Sep 2026) and the titles no longer
// carry it. Perk SKUs never reach this list — the section filters them out.
function isTopper(p) {
  return (p.type || '').toLowerCase() === 'toppers';
}

function findShakersProduct(products, support) {
  if (!products) return null;

  // Map quiz support answers to topper title keywords
  const supportToKeyword = {
    'hip and joint health': 'hip',
    'skin and coat health': 'skin',
    'immune health': 'multivitamin',
    'dental health': 'multivitamin',
    'overall health': 'multivitamin'
  };

  // Get keyword from the first support selection
  const firstSupport = (Array.isArray(support) ? support[0] : support || '').toLowerCase();

  if (firstSupport === 'none' || !firstSupport) {
    // "None" selected or no support data — default to Multivitamins
    return products.find(p => isTopper(p) && p.title.toLowerCase().includes('multivitamin'));
  }

  const keyword = supportToKeyword[firstSupport];
  if (keyword) {
    const match = products.find(p => isTopper(p) && p.title.toLowerCase().includes(keyword));
    if (match) return match;
  }

  // Fallback: first topper
  return products.find(isTopper);
}

function findTreatProduct(products, flavor, treatType) {
  if (!products) return null;
  return products.find(p => {
    const title = p.title.toLowerCase();
    return title.includes(treatType) && title.includes(flavor.toLowerCase());
  });
}

function renderDogTabs(data) {
  const container = document.getElementById('quiz-results-dog-tabs');
  if (!container) return;

  const params = new URLSearchParams(window.location.search);
  const currentCdi = parseInt(params.get('cdi') || '0', 10);
  let dogData = [];

  if (data.source === 'url') {
    const names = (params.get('n') || '').split(',').filter(n => n);
    dogData = names.map(name => ({ name, completed: true }));
  } else {
    const savedData = localStorage.getItem('kismet_quiz_data');
    if (savedData) {
      const localData = JSON.parse(savedData);
      const dogCount = parseInt(localData.dogCount, 10) || 1;
      if (localData.dogs && localData.dogs.length > 0) {
        dogData = localData.dogs.slice(0, dogCount).map(dog => ({
          name: dog.name || 'Dog',
          completed: dog.completed === true || (dog.currentStep && dog.currentStep > 7)
        }));
      }
    }
  }

  if (dogData.length <= 1) {
    container.style.display = 'none';
    return;
  }

  container.style.display = 'flex';
  container.innerHTML = dogData.map((dog, index) => {
    const isActive = index === currentCdi;
    const isIncomplete = !dog.completed;
    const newParams = new URLSearchParams(window.location.search);
    newParams.set('cdi', index);
    const url = `${window.location.pathname}?${newParams.toString()}`;

    const classes = ['quiz-tab'];
    if (isActive) classes.push('active');
    if (isIncomplete) classes.push('incomplete');

    // Use inline onclick handler calling the switchDog function
    return `<a href="${url}" class="${classes.join(' ')}" onclick="switchDog(event, ${index})">${dog.name}</a>`;
  }).join('');
}

// Global scope function for onclick attribute in dog tabs
window.switchDog = function(event, dogIndex) {
  event.preventDefault();

  // Don't switch if already on this dog
  const params = new URLSearchParams(window.location.search);
  const currentCdi = parseInt(params.get('cdi') || '0', 10);
  if (dogIndex === currentCdi) return;

  // 1. Fade out current content
  document.querySelectorAll('.quiz-results-main, .quiz-purchase-options, .quiz-buy-separately').forEach(el => {
    el.classList.remove('visible');
  });

  // Hide incomplete message if showing
  const incompleteMsg = document.querySelector('.quiz-incomplete-message');
  if (incompleteMsg) {
    incompleteMsg.remove();
  }

  // 2. Update URL without reloading (for back button support)
  const newParams = new URLSearchParams(window.location.search);
  newParams.set('cdi', dogIndex);
  window.history.pushState({ cdi: dogIndex }, '', `${window.location.pathname}?${newParams.toString()}`);

  // 3. After fade out (300ms), update content
  setTimeout(() => {
    // Get quiz data for the new dog
    const quizData = getQuizDataForDog(dogIndex);

    // Update tabs (mark the active one)
    updateActiveTabs(dogIndex);

    // Check if dog is complete
    if (!isDogCompleteByIndex(dogIndex, quizData)) {
      showIncompleteMessage(quizData);
      return;
    }

    // Show main content containers
    document.querySelectorAll('.quiz-results-main, .quiz-purchase-options').forEach(el => {
      el.style.display = '';
    });

    // Render new content
    renderDogInfo(quizData);
    renderRecommendedProducts(quizData);
    renderIndividualProducts(quizData);

    // Fade in content
    document.querySelectorAll('.quiz-results-main, .quiz-purchase-options, .quiz-buy-separately').forEach(el => {
      el.classList.add('visible');
    });

    // Notify other sections
    window.dispatchEvent(new CustomEvent('quizResultsReady', { detail: window.quizResultsData }));
  }, 300);
}

// Helper: Get quiz data for a specific dog index
function getQuizDataForDog(dogIndex) {
  const params = new URLSearchParams(window.location.search);

  // Try URL params first
  if (params.has('n')) {
    try {
      const names = (params.get('n') || '').split(',');
      const breeds = (params.get('b') || '').split(',').map(b => decodeURIComponent(b));
      const weights = (params.get('w') || '').split(',');
      const calories = (params.get('cal') || '').split(',');
      const foodFlavors = (params.get('ff') || '').split(',');
      const treatFlavors = (params.get('tf') || '').split(',');
      const bagWeights = (params.get('bw') || '').split(',');
      const cadences = (params.get('dc') || '').split(',');
      const support = (params.get('sp') || '').split(',');

      const getFlavor = (num) => {
        if(num == '1') return 'salmon';
        if(num == '2') return 'beef';
        if(num == '3') return 'chicken';
        return 'chicken';
      };

      if (names[dogIndex]) {
        return {
          source: 'url',
          dogName: names[dogIndex],
          dogBreed: breeds[dogIndex] || '',
          weight: parseFloat(weights[dogIndex] || 0),
          calories: parseInt(calories[dogIndex] || 0),
          bagWeight: bagWeights[dogIndex],
          deliveryCadence: parseInt(cadences[dogIndex] || 4),
          foodFlavor: getFlavor(foodFlavors[dogIndex]),
          treatFlavor: getFlavor(treatFlavors[dogIndex]),
          support: support[dogIndex] ? [support[dogIndex]] : [],
          allergies: foodFlavors[dogIndex] == '1'
        };
      }
    } catch (e) { console.error('[Quiz Results] Error parsing URL params:', e); }
  }

  // Fall back to localStorage
  const savedData = localStorage.getItem('kismet_quiz_data');
  if (savedData) {
    const data = JSON.parse(savedData);
    const dog = data.dogs && data.dogs[dogIndex] ? data.dogs[dogIndex] : null;
    if (dog) {
      return {
        source: 'local',
        dogName: dog.name || 'Your dog',
        dogBreed: dog.breed,
        weight: parseFloat(dog.weight) || 0,
        activityLevel: dog.activityLevel,
        size: dog.size,
        spayedOrNeutered: dog.spayedOrNeutered === 'true' || dog.spayedOrNeutered === true,
        birthdayMonth: dog.birthdayMonth,
        birthdayDay: parseInt(dog.birthdayDay) || 1,
        birthdayYear: parseInt(dog.birthdayYear) || 2023,
        allergies: dog.allergies === 'true' || dog.allergies === true,
        support: dog.support,
        diet: dog.diet,
        gender: dog.gender
      };
    }
  }
  return null;
}

// Helper: Update active state on tabs
function updateActiveTabs(activeIndex) {
  document.querySelectorAll('.quiz-tab').forEach((tab, index) => {
    tab.classList.toggle('active', index === activeIndex);
  });
}

// Helper: Check if a dog is complete by index
function isDogCompleteByIndex(dogIndex, quizData) {
  const savedData = localStorage.getItem('kismet_quiz_data');
  if (!savedData) return false;
  const data = JSON.parse(savedData);
  const dog = data.dogs && data.dogs[dogIndex];
  if (!dog) return false;
  if (dog.completed === true) return true;
  if (dog.currentStep && dog.currentStep > 7) return true;
  if (quizData && quizData.source === 'url' && quizData.calories > 0) return true;
  if (dog.currentStep !== undefined) return false;
  return dog.breed && dog.weight > 0 && dog.activityLevel && dog.diet && dog.size && dog.gender;
}

// Handle browser back/forward navigation
window.addEventListener('popstate', function(event) {
  const params = new URLSearchParams(window.location.search);
  const cdi = parseInt(params.get('cdi') || '0', 10);
  // Use a fake event object since we're triggering programmatically
  if (window.switchDog) {
     window.switchDog({ preventDefault: () => {} }, cdi);
  }
});

function initPurchaseOptions() {
  let quantity = 1;
  let isSubscription = true;
  let selectedFrequencyWeeks = 4; // Default frequency in weeks

  // Helper to extract weeks from a selling plan (by name or options)
  function extractWeeksFromPlan(plan) {
    // Try plan.options first (more reliable, e.g. { value: "8 Weeks" })
    if (plan.options && plan.options.length > 0) {
      for (const opt of plan.options) {
        const val = (opt.value || '').toLowerCase();
        const wm = val.match(/(\d+)\s*week/);
        if (wm) return parseInt(wm[1]);
        const dm = val.match(/(\d+)\s*day/);
        if (dm) return Math.round(parseInt(dm[1]) / 7);
      }
    }

    // Fallback to plan name
    const planName = (plan.name || '').toLowerCase();
    const weeksMatch = planName.match(/(\d+)\s*week/);
    if (weeksMatch) return parseInt(weeksMatch[1]);
    const daysMatch = planName.match(/(\d+)\s*day/);
    if (daysMatch) return Math.round(parseInt(daysMatch[1]) / 7);
    if (planName.includes('month')) return 4;

    return null;
  }

  // Helper to find a selling plan matching the selected frequency
  function findSellingPlanForFrequency(product, frequencyWeeks) {
    if (!product.selling_plan_groups || product.selling_plan_groups.length === 0) {
      return null;
    }

    // Build a list of all plans with their extracted week values
    const allPlans = [];
    for (const group of product.selling_plan_groups) {
      for (const plan of group.selling_plans) {
        const weeks = extractWeeksFromPlan(plan);
        allPlans.push({ id: plan.id, name: plan.name, weeks });
      }
    }

    // 1. Exact match
    const exact = allPlans.find(p => p.weeks === frequencyWeeks);
    if (exact) return exact.id;

    // 2. Closest match (prefer the nearest plan, biased toward longer intervals)
    const withWeeks = allPlans.filter(p => p.weeks !== null);
    if (withWeeks.length > 0) {
      withWeeks.sort((a, b) => Math.abs(a.weeks - frequencyWeeks) - Math.abs(b.weeks - frequencyWeeks));
      return withWeeks[0].id;
    }

    // 3. Last resort: first plan (should rarely happen)
    if (allPlans.length > 0) {
      console.warn('[Quiz] Could not determine weeks for any plan, using first available:', allPlans[0].name);
      return allPlans[0].id;
    }

    return null;
  }

  // Helper to get the subscription price for a variant with a specific selling plan
  function getSubscriptionPrice(variant, sellingPlanId) {
    if (!variant.selling_plan_allocations || !sellingPlanId) {
      // Fallback to 30% discount if no allocations available
      return Math.round(variant.price * 0.7);
    }

    const allocation = variant.selling_plan_allocations.find(a => a.selling_plan_id === sellingPlanId);
    return allocation ? allocation.price : Math.round(variant.price * 0.7);
  }

  // Helper to get the correct variant for a product
  function getVariantForProduct(product) {
    if (product.type === 'food' && product.bagWeight) {
      return product.variants.find(v => v.title.includes(product.bagWeight)) || product.variants[0];
    }
    return product.variants[0];
  }

  function updatePricing() {
    if (!window.quizResultsData || !window.quizResultsData.recommendations || !window.quizResultsData.recommendations.products) return;

    const products = window.quizResultsData.recommendations.products;
    let totalOneTimePrice = 0;
    let totalSubscriptionPrice = 0;

    products.forEach(product => {
      const variant = getVariantForProduct(product);
      if (!variant) return;

      totalOneTimePrice += variant.price;

      // Get the selling plan for this product and frequency
      const sellingPlanId = findSellingPlanForFrequency(product, selectedFrequencyWeeks);
      totalSubscriptionPrice += getSubscriptionPrice(variant, sellingPlanId);
    });

    totalOneTimePrice = totalOneTimePrice * quantity;
    totalSubscriptionPrice = totalSubscriptionPrice * quantity;

    const priceElement = document.getElementById('quiz-price');
    const originalPriceElement = document.getElementById('quiz-price-original');
    const onetimePriceElement = document.getElementById('onetime-price-display');

    if (priceElement) {
      if (isSubscription) {
        priceElement.textContent = formatPrice(totalSubscriptionPrice);
        if (originalPriceElement) {
          originalPriceElement.textContent = formatPrice(totalOneTimePrice);
          originalPriceElement.style.display = 'inline';
        }
      } else {
        priceElement.textContent = formatPrice(totalOneTimePrice);
        if (originalPriceElement) {
          originalPriceElement.style.display = 'none';
        }
      }
    }
    if (onetimePriceElement) {
      onetimePriceElement.textContent = formatPrice(totalOneTimePrice);
    }
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Purchase type toggle (subscription vs one-time)
  document.querySelectorAll('input[name="purchase-type"]').forEach(radio => {
    radio.addEventListener('change', function() {
      isSubscription = this.value === 'subscription';
      updatePricing();
    });
  });

  // Frequency select change
  const frequencySelect = document.getElementById('delivery-frequency');
  if (frequencySelect) {
    // Set initial frequency from select value
    selectedFrequencyWeeks = parseInt(frequencySelect.value) || 4;

    frequencySelect.addEventListener('change', function() {
      selectedFrequencyWeeks = parseInt(this.value) || 4;
      updatePricing();
    });
  }

  const qtyDecrease = document.getElementById('qty-decrease');
  if (qtyDecrease) {
    qtyDecrease.addEventListener('click', function() {
      if (quantity > 1) {
        quantity--;
        document.getElementById('qty-display').textContent = quantity;
        updatePricing();
      }
    });
  }

  const qtyIncrease = document.getElementById('qty-increase');
  if (qtyIncrease) {
    qtyIncrease.addEventListener('click', function() {
      quantity++;
      document.getElementById('qty-display').textContent = quantity;
      updatePricing();
    });
  }

  const addToCartBtn = document.getElementById('add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async function() {
      if (!window.quizResultsData || !window.quizResultsData.recommendations || !window.quizResultsData.recommendations.products) {
        alert('No products to add');
        return;
      }

      const items = [];
      const products = window.quizResultsData.recommendations.products;

      products.forEach(product => {
        const variant = getVariantForProduct(product);
        if (!variant) return;

        const item = {
          id: variant.id,
          quantity: quantity
        };

        // Add selling_plan only if subscription is selected
        if (isSubscription) {
          const sellingPlanId = findSellingPlanForFrequency(product, selectedFrequencyWeeks);
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }
        }

        items.push(item);
      });

      if (items.length === 0) {
        alert('No products to add');
        return;
      }

      // Show loading state
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-ajax'] })
        });

        if (response.ok) {
          const data = await response.json();

          // Show success state
          addToCartBtn.textContent = 'Added to Cart!';
          addToCartBtn.classList.add('success');

          // Dispatch standard cart event so header cart drawer updates and opens
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: data, addToCartBtn }
          }));

          // Reset button after 2 seconds
          setTimeout(() => {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.classList.remove('success');
          }, 2000);
        } else {
          const errorData = await response.json().catch(() => ({}));
          console.error('Cart error:', errorData);
          alert(errorData.description || 'Error adding to cart. Please try again.');
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        alert('Error adding to cart. Please try again.');
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      }
    });
  }

  updatePricing();
}

function showError(message) {
  const wrapper = document.getElementById('quiz-results-wrapper');
  if (!wrapper) return;

  const quizUrl = (window.quizResultsData && window.quizResultsData.quizUrl) || '/pages/quiz';

  if (!message) {
    wrapper.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 2rem; background: #f9dab2;">
        <p style="color: #036356; font-size: 24px; text-align: center;">Please take the quiz first!</p>
        <a href="${quizUrl}" class="quiz-retake-btn" style="background: transparent; color: #036356; border: 2px solid #036356; border-radius: 50px; padding: 1rem 3rem; font-family: 'Apercu', sans-serif; font-size: 18px; text-decoration: none;">Take Quiz</a>
      </div>
    `;
  } else {
    wrapper.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 2rem; background: #f9dab2;">
        <p style="color: #036356; font-size: 24px; text-align: center;">${message}</p>
        <a href="${quizUrl}" class="quiz-retake-btn" style="background: transparent; color: #036356; border: 2px solid #036356; border-radius: 50px; padding: 1rem 3rem; font-family: 'Apercu', sans-serif; font-size: 18px; text-decoration: none;">Retake Quiz</a>
      </div>
    `;
  }
}
